import React from 'react'

import BaseSelect, { Props as BaseProps } from './base'

export interface Props<T> extends Omit<BaseProps<T>, 'value' | 'onSelect' | 'multiple'> {
  value?: T
  onSelect?: (value: T) => void
  searchable?: boolean
}
const Select = (props: Props<any>) => {
  return <BaseSelect {...props} />
}

Select.Skeleton = BaseSelect.Skeleton

export default Select
